import React, { useState, useCallback, useEffect, useRef } from "react";
import { Dropdown, NavItem } from "react-bootstrap";
import { Link } from "react-router-dom";
//import { Trans } from "react-i18next";
import FlagDropDown from "../util/FlagDropDown";
// import { Navbar, Nav, NavItem, Container } from "reactstrap";
import { useTranslation } from "react-i18next";
import http from "../../services/HttpService";
import { useHistory } from "react-router-dom";
import Role from "../Components/Role";

function Navbar(props) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const [languageMenuOpened, setLanguageMenuOpened] = useState(false);
  const refLanguageMenu = useRef(null);

  const toggleOffcanvas = () => {
    document.querySelector(".sidebar-offcanvas").classList.toggle("active");
  };
  const toggleRightSidebar = () => {
    document.querySelector(".right-sidebar").classList.toggle("open");
  };

  const changeLanguage = (e) => {
    const lng = e.currentTarget.dataset.lang;
    i18n.changeLanguage(lng);

    if ("function" === typeof props.changeLang) {
      props.changeLang();
    }
  };

  const onLanguageMenuClick = useCallback((event) => {
    if (refLanguageMenu.current && event.target) {
      const menu = refLanguageMenu.current;
      const clicked = event.target;
      if (menu.contains(clicked)) {
        return;
      }
    }

    event.preventDefault();
    event.stopPropagation();

    // setLanguageMenuOpened((opened: boolean) => !opened);
    setLanguageMenuOpened((opened) => !opened);
  }, []);

  const logout = (event) => {
    event.preventDefault();

    http.removeDefaultHeader("Authorization");

    http
      .post("/auth/logout")
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          localStorage.removeItem("access_token");
          localStorage.removeItem("user");
          localStorage.removeItem("permissions");
          history.push("/login");
        }
      });
  };

  return (
    <nav className="navbar p-0 fixed-top d-flex flex-row">
      <div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
        <Link className="navbar-brand brand-logo-mini" to="/">
          <img
            src={require("../../assets/images/logo-mini-1.png")}
            alt="logo"
          />
        </Link>
      </div>
      <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch">
        <button
          className="navbar-toggler align-self-center"
          type="button"
          onClick={() => document.body.classList.toggle("sidebar-icon-only")}
        >
          <span className="mdi mdi-menu"></span>
        </button>
        <ul className="navbar-nav w-100">
          <li className="nav-item w-100">
            <form className="nav-link mt-2 mt-md-0 d-none d-lg-flex search">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
              />
            </form>
          </li>
        </ul>
        <ul className="navbar-nav navbar-nav-right">
          <NavItem
            className="languages_block_style"
            onClick={onLanguageMenuClick}
          >
            <FlagDropDown
              ref={refLanguageMenu}
              opened={languageMenuOpened}
              onLangClick={changeLanguage}
            />
          </NavItem>
          <Dropdown alignRight as="li" className="nav-item">
            <Dropdown.Toggle
              as="a"
              className="nav-link count-indicator cursor-pointer"
            >
              <i className="mdi mdi-email"></i>
              <span className="count bg-success"></span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="navbar-dropdown preview-list">
              <h6 className="p-3 mb-0 mess-he">Messages</h6>
              <Dropdown.Divider />
              <Dropdown.Item
                href="!#"
                onClick={(evt) => evt.preventDefault()}
                className="preview-item"
              >
                <div className="preview-thumbnail">
                  <div className="preview-icon bg-dark rounded-circle">
                    <img
                      src={require("../../assets/images/faces/face4.jpg")}
                      alt="profile"
                      className="rounded-circle profile-pic"
                    />
                  </div>
                </div>
                <div className="preview-item-content">
                  <p className="preview-subject ellipsis mb-1">
                    Mark send you a message
                  </p>
                  <p className="text-muted mb-0 ">1 Minutes ago</p>
                </div>
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                href="!#"
                onClick={(evt) => evt.preventDefault()}
                className="preview-item"
              >
                <div className="preview-thumbnail">
                  <div className="preview-icon bg-dark rounded-circle">
                    <img
                      src={require("../../assets/images/faces/face2.jpg")}
                      alt="profile"
                      className="rounded-circle profile-pic"
                    />
                  </div>
                </div>
                <div className="preview-item-content">
                  <p className="preview-subject ellipsis mb-1">
                    Cregh send you a message
                  </p>
                  <p className="text-muted mb-0">15 Minutes ago</p>
                </div>
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                href="!#"
                onClick={(evt) => evt.preventDefault()}
                className="preview-item"
              >
                <div className="preview-thumbnail">
                  <div className="preview-icon bg-dark rounded-circle">
                    <img
                      src={require("../../assets/images/faces/face3.jpg")}
                      alt="profile"
                      className="rounded-circle profile-pic"
                    />
                  </div>
                </div>
                <div className="preview-item-content">
                  <p className="preview-subject ellipsis mb-1">
                    Profile picture updated
                  </p>
                  <p className="text-muted mb-0">18 Minutes ago</p>
                </div>
              </Dropdown.Item>
              <Dropdown.Divider />
              <p className="p-3 mb-0 text-center mess-fo">4 new messages</p>
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown alignRight as="li" className="nav-item border-left">
            <Dropdown.Toggle
              as="a"
              className="nav-link count-indicator cursor-pointer"
            >
              <i className="mdi mdi-bell"></i>
              <span className="count bg-danger"></span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu navbar-dropdown preview-list">
              <h6 className="p-3 mb-0 not-he">Notifications</h6>
              <Dropdown.Divider />
              <Dropdown.Item
                className="dropdown-item preview-item"
                onClick={(evt) => evt.preventDefault()}
              >
                <div className="preview-thumbnail">
                  <div className="preview-icon new-mess-back rounded-circle">
                    <i className="mdi mdi-calendar text-success"></i>
                  </div>
                </div>
                <div className="preview-item-content">
                  <p className="preview-subject mb-1">Event today</p>
                  <p className="text-muted ellipsis mb-0">
                    Just a reminder that you have an event today
                  </p>
                </div>
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                className="dropdown-item preview-item"
                onClick={(evt) => evt.preventDefault()}
              >
                <div className="preview-thumbnail">
                  <div className="preview-icon new-mess-back rounded-circle">
                    <i className="mdi mdi-account-settings text-danger"></i>
                  </div>
                </div>
                <div className="preview-item-content">
                  <h6 className="preview-subject mb-1">Settings</h6>
                  <p className="text-muted ellipsis mb-0">Update dashboard</p>
                </div>
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                className="dropdown-item preview-item"
                onClick={(evt) => evt.preventDefault()}
              >
                <div className="preview-thumbnail">
                  <div className="preview-icon new-mess-back rounded-circle">
                    <i className="mdi mdi-link-variant text-warning"></i>
                  </div>
                </div>
                <div className="preview-item-content">
                  <h6 className="preview-subject mb-1">Launch Admin</h6>
                  <p className="text-muted ellipsis mb-0">New admin wow</p>
                </div>
              </Dropdown.Item>
              <Dropdown.Divider />
              <p className="p-3 mb-0 text-center not-fo">
                See all notifications
              </p>
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown alignRight as="li" className="nav-item">
            <Dropdown.Toggle
              as="a"
              className="nav-link cursor-pointer no-caret"
            >
              <div className="navbar-profile">
                <img
                  className="img-xs rounded-circle"
                  src={require("../../assets/images/faces/face15.jpg")}
                  alt="profile"
                />
                <p className="mb-0 d-none d-sm-block navbar-profile-name">
                  {userInfo && userInfo.first_name}{" "}
                  {userInfo && userInfo.last_name}
                  <span>
                  {userInfo && <Role role={userInfo && userInfo.role} style="new-workers-role-style" />}
                  </span>
                </p>
                <i className="mdi mdi-menu-down d-none d-sm-block"></i>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu className="navbar-dropdown preview-list navbar-profile-dropdown-menu">
              <h6 className="p-3 mb-0 new-profile-color">Profile</h6>
              <Dropdown.Divider />
              <Dropdown.Item
                href="!#"
                onClick={(evt) => evt.preventDefault()}
                className="preview-item"
              >
                <div className="preview-thumbnail">
                  <div className="preview-icon new-s-l-bg rounded-circle">
                    <i className="mdi mdi-account-settings text-success"></i>
                  </div>
                </div>
                <div className="preview-item-content">
                  <p className="preview-subject mb-1 ">Settings</p>
                </div>
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                href="!#"
                onClick={(evt) => evt.preventDefault()}
                className="preview-item"
              >
                <Link to="#" onClick={logout} className="new_logout_link">
                  <div className="preview-thumbnail">
                    <div className="preview-icon new-s-l-bg rounded-circle">
                      <i className="mdi mdi-logout text-danger"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject mb-1">Log Out</p>
                  </div>
                </Link>
              </Dropdown.Item>
              <Dropdown.Divider />
              <p className="p-3 mb-0 text-center new-ad-set">
                Advanced settings
              </p>
            </Dropdown.Menu>
          </Dropdown>
        </ul>
        <button
          className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
          type="button"
          onClick={toggleOffcanvas}
        >
          <span className="mdi mdi-format-line-spacing"></span>
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
